var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationtoursearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_7733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6735 0C28.5111 0 12.1641 16.3471 12.1641 36.5094C12.1641 44.4487 14.7669 51.7338 19.0932 57.7001C19.1708 57.843 19.183 58.0028 19.2712 58.1397L43.6108 94.6491C44.7396 96.3422 46.6411 97.3584 48.6735 97.3584C50.7058 97.3584 52.6073 96.3422 53.7361 94.6491L78.0757 58.1397C78.1654 58.0028 78.1761 57.843 78.2537 57.7001C82.58 51.7338 85.1829 44.4487 85.1829 36.5094C85.1829 16.3471 68.8358 0 48.6735 0ZM48.6735 48.6792C41.9527 48.6792 36.5037 43.2302 36.5037 36.5094C36.5037 29.7886 41.9527 24.3396 48.6735 24.3396C55.3942 24.3396 60.8433 29.7886 60.8433 36.5094C60.8433 43.2302 55.3942 48.6792 48.6735 48.6792Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_7733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.3584,
    height: 97.3584,
    fill: "white",
    transform: "translate(-0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationtoursearch);
export default __webpack_public_path__ + "static/media/location tour search.1a0e98681a1a4a41b2954ce082a4b813.svg";
export { ForwardRef as ReactComponent };